export default "__VITE_ASSET__DGhr0tmY__"